import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import { IUserDetails } from '../../../common/types/user.model';

interface IUserListAutoCompleteProps {
  list: IUserDetails[];
  value: IUserDetails[];
  onAdd: (option: IUserDetails) => void;
}

export default function UserListAutoComplete({
  list,
  value,
  onAdd
}: IUserListAutoCompleteProps) {
  return (
    <Autocomplete
      multiple
      id='user-list'
      options={list}
      filterOptions={(options, state) =>
        state.inputValue
          ? options.filter(
              (user) =>
                user.last_name
                  .toLowerCase()
                  .includes(state.inputValue.toLowerCase()) ||
                user.first_name
                  .toLowerCase()
                  .includes(state.inputValue.toLowerCase()) ||
                user.email
                  .toLowerCase()
                  .includes(state.inputValue.toLowerCase())
            )
          : options
      }
      value={value}
      noOptionsText='No users found'
      filterSelectedOptions
      onChange={(_e, _value, reason, details) => {
        if (reason === 'selectOption') {
          onAdd(details.option);
        }
      }}
      renderTags={() => null}
      renderOption={(renderOptionProps, option) => (
        <li {...renderOptionProps} key={option.id}>
          <Grid container flexDirection='column' alignItems='baseline'>
            <Typography fontSize='12px' fontWeight={700}>
              {option.first_name} {option.last_name}
            </Typography>
            <Typography fontSize='10px' ml={1} color='#656565' fontWeight={700}>
              {option.email}
            </Typography>
          </Grid>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant='standard'
          label='Select User'
          placeholder='Search'
        />
      )}
    />
  );
}
